var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insured-value"},[_c('label',{staticClass:"label",attrs:{"for":"insured-value"}},[_c('strong',[_vm._v("Insured value:")]),_vm._v(" "),_c('span',[_vm._v("$"+_vm._s(_vm.insuredValue))])])])}
var staticRenderFns = []

export { render, staticRenderFns }